import type { AxiosProgressEvent } from "axios";

/**
 * Wraps a percent (0-100) callback into the shape axios's `onUploadProgress`
 * expects. Axios delivers an AxiosProgressEvent (loaded/total/progress/...);
 * our composables and components want a plain percent number.
 *
 * Use at every `apiService.post(url, formData, { onUploadProgress: ... })`
 * site that wants to thread `useAttachmentFormSave`'s `onUploadProgress`
 * through to the network layer.
 */
export const toAxiosUploadProgress = (
  callback: ((percent: number) => void) | undefined,
): ((event: AxiosProgressEvent) => void) | undefined => {
  if (callback === undefined) {
    return undefined;
  }

  return (event: AxiosProgressEvent) => {
    if (!event.total) {
      return;
    }
    callback(Math.round((event.loaded / event.total) * 100));
  };
};
